import { render, staticRenderFns } from "./RegisterTest.vue?vue&type=template&id=1949aa2e&scoped=true&"
import script from "./RegisterTest.vue?vue&type=script&lang=js&"
export * from "./RegisterTest.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTest.vue?vue&type=style&index=0&id=1949aa2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1949aa2e",
  null
  
)

export default component.exports